import { AppDomainConstant } from "../../app-domain.constant";


export class ConfiguracionContableProductosApiConstant {

    static readonly BASE_CONFIGURACION_CONTABLE: string = 'api/v1/control-operacion-producto-contables/';

    static readonly BASE_PARAMETRIZACION: string = 'api/v1/parametrizaciones/';

    static readonly BASE_CATEGORIZACION_CONVENIOS: string = 'api/v1/gestion-categorizacion-convenios/categorizacion-convenio/';

    static readonly BASE_GESTION_CONTRATOS: string = 'api/v1/gestion-contratos/';

    static readonly BASE_PARAMETRIZACION_PRODUCTOS: string = 'api/v1/control-operacion-parametrizacion-producto/';

    static readonly URL_CATEGORIA: string = 'categoria-producto';

    static readonly BASE_URL_RESOURCES: string = "api/v1/resource-management/"

    static readonly BASE_MULTIEMPRESAS: string = 'api/v1/multiempresa/';


    static readonly URL_GET_LISTADO_CONFIG_CONTABLE: string = 
    AppDomainConstant.URI_GATEWAY +
    this.BASE_CONFIGURACION_CONTABLE +
    'configuracion-producto';

    static readonly URL_GET_CONFIG_PRODUCTO: string = 
    AppDomainConstant.URI_GATEWAY +
    this.BASE_CONFIGURACION_CONTABLE +
    'configuracion-producto/find-by-id';

    static readonly URL_SAVE_UPDATE_CONFIG_CONTABLE: string = 
    AppDomainConstant.URI_GATEWAY +
    this.BASE_CONFIGURACION_CONTABLE +
    'configuracion-contable-productos';

    static readonly URL_SAVE_UPDATE_CONFIG_PRODUCTO: string = 
    AppDomainConstant.URI_GATEWAY +
    this.BASE_CONFIGURACION_CONTABLE +
    'configuracion-producto';
    

    static readonly URL_GET_CONCEPTOS_CONTABLES: string =
    AppDomainConstant.URI_GATEWAY +
    this.BASE_CONFIGURACION_CONTABLE +
    'concepto-contable'

    static readonly URL_GET_CUENTAS_CONTABLES: string =
    AppDomainConstant.URI_GATEWAY +
    this.BASE_CONFIGURACION_CONTABLE +
    'cuenta-contable'

    static readonly URL_GET_CATEGORIAS: string =
    AppDomainConstant.URI_GATEWAY + 
    this.BASE_PARAMETRIZACION_PRODUCTOS +
    this.URL_CATEGORIA;

    static readonly URL_GET_PRODUCTOS: string = 
    AppDomainConstant.URI_GATEWAY +
    this.BASE_PARAMETRIZACION_PRODUCTOS + 
    'producto'

    static readonly URL_GET_SUBPRODUCTOS: string = 
    AppDomainConstant.URI_GATEWAY +
    this.BASE_PARAMETRIZACION_PRODUCTOS + 
    'producto/sub-producto'

    static readonly URL_GET_TIPOS_CONTRATO: string =
    AppDomainConstant.URI_GATEWAY +
    this.BASE_GESTION_CONTRATOS +
    'contrato-aliado'


    static readonly URL_GET_PARAMETRO: string = 
    AppDomainConstant.URI_GATEWAY +
    this.BASE_PARAMETRIZACION +
    'parametro-contable'

    static readonly URL_GET_CATEGORIZACION_CONVENIOS: string =
    AppDomainConstant.URI_GATEWAY +
    this.BASE_CATEGORIZACION_CONVENIOS +
    'producto-id'

    static readonly URL_GET_CATEGORIAS_CONVENIOS: string =
    AppDomainConstant.URI_GATEWAY +
    this.BASE_PARAMETRIZACION +
    'categoria-convenios'

    static readonly URL_LOAD_RESOURCE: string =
    AppDomainConstant.URI_GATEWAY +
    this.BASE_URL_RESOURCES + 'file';

    static readonly URL_GET_EMPRESAS: string =
    AppDomainConstant.URI_GATEWAY +
    this.BASE_MULTIEMPRESAS +
    'empresas/all';

}